<template>
  <div>
    <el-form ref="formData" :rules="rules" :model="formData" :disabled="flowStatus">
      <el-row :gutter="24">
        <el-col :span="24">
          <div class="midd-content">流程描述：{{ flowDescribe }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="标题" prop="title">
            <el-input v-model.trim="formData.title" size="small" maxlength="30" show-word-limit :disabled="flowStatus">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="编号" prop="code">
            <el-input
              type="text"
              v-model="formData.code"
              placeholder="系统自动生成"
              maxlength="20"
              show-word-limit
              size="small"
              disabled
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="工程名称" prop="projectName">
            <el-input
              type="text"
              v-model="formData.projectName"
              maxlength="50"
              show-word-limit
              size="small"
              :disabled="flowStatus"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="致" prop="companyId">
            <el-select style="width: 100%" size="small" v-model="formData.companyId">
              <el-option :key="index" v-for="(item, index) in companyList" :label="item.company" :value="item.companyId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="内容" prop="content">
            <el-input
              v-model.trim="formData.content"
              :autosize="{ minRows: 4, maxRows: 6 }"
              type="textarea"
              style="width: 100%"
              maxlength="200"
              show-word-limit
              :disabled="flowStatus"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24" style="line-height: 20px; margin-top: 15px">
        <el-col :span="24">
          <el-form-item label="附件">
            <div style="float: left">
              <el-button v-if="!flowStatus" size="small" @click="uploadFolder('guanlianfile')"> <i class="el-icon-plus"></i>关联文档 </el-button>
              <el-button v-if="!flowStatus" size="small" @click="uploadFolder('file')"> <i class="el-icon-plus"></i>本地上传 </el-button>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- 通用关联文件 -->
    <el-dialog
      v-dialogDrag
      :visible.sync="fileDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :close="cancel"
      title="关联文件"
      width="600px"
      append-to-body
    >
      <el-tree
        ref="localTree"
        :load="getlocalTree"
        :data="localTree"
        :props="defaultFileProps"
        :check-on-click-node="true"
        :class="[{ activeShowBar: !showBar }]"
        class="tree"
        lazy
        accordion
        highlight-current
        show-checkbox
        @check="currentOrgChangeHandlerLocal"
      >
        <template #default="{ data }">
          <span class="treeitem">
            <img v-if="data.isFolder == 0" :src="className(data)" class="img" alt="" />
            <img v-else :src="icon" class="img" alt="" />
            {{ data.folderName }}
          </span>
        </template>
      </el-tree>
      <span slot="footer">
        <el-button type="primary" size="small" @click="filerecelocationBtn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { tableRowIcon } from "@/CommonDP/utils/docPublic";
import { getApprove } from "@/CommonDP/components/processComponents/flowNewConfig/mapStore.js";
import docService from "@/CommonDP/service/doc-service";
import designService from "@/views/flowComponents/service/design-change-service";
import { uploader } from "@/CommonDP/utils/IUploader/dp.js";

export default {
  props: {
    uuid: {
      type: String,
      default: "",
    }, // 唯一标识
    list: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      icon: require("@/CommonDP/assets/doc/folder_icon.png"),
      companyList: [],
      rules: {
        title: [{ required: true, message: "请填写标题", trigger: "blur" }],
        // content: [{ required: true, message: "请填写内容", trigger: "blur" }],
        projectName: [{ required: true, message: "请填写工程名称", trigger: "blur" }],
        companyId: [{ required: true, message: "请填写城市ID", trigger: "blur" }],
      },
      fileDialog: false,
      defaultFileProps: {
        children: "childList",
        label: "folderName",
        isLeaf: "leaf",
      },
      loading: false,
      node_had: {},
      localTree: [],
      resolve_had: {},
      messageObj: {},
      flowStatus: false,
      formData: { title: "" },
    };
  },
  watch: {},
  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj,
      routerParams: (state) => state.projectMg.routerParams,
      userInfo: (state) => state.user.userInfo,
    }),
    approveInfo() {
      return getApprove(this.uuid);
    },
    prjId() {
      return this.approveInfo.getPrjId() || this.prjInfo.prjId;
    },
    showBar() {
      return this.$store.state.app.showBar;
    },
    tableData() {
      return this.list || [];
    },

    flowDescribe() {
      return decodeURI(this.routerParams.description) || "";
    },
  },
  async created() {
    this.formData.approveUserName = this.userInfo.name;
    this.formData.title = this.userInfo.name + "发起" + this.routerParams.name;
    this.$set(this.formData, 'projectName', this.prjInfo.prjName)
    await this.getCompanyList();
  },
  methods: {
    async getCompanyList() {
      const res = await designService.getCompanyList(this.prjId).catch((err) => console.error("获取公司列表异常"));
      if (Array.isArray(res?.data)) {
        this.companyList = res.data;
      }
    },
    // 接口：用于获取表单数据
    getFormData() {
      const companyId = this.formData.companyId;
      const companyName = this.companyList.find((item) => item.companyId == companyId)?.company;
      return {
        ...this.formData,
        companyName,
      };
    },

    // 接口：设置表单数据
    setFormData(formData) {
      this.formData = formData;
    },
    // 重置表单数据
    resetForm() {
      this.formData.approveUserName = this.userInfo.name;
      this.formData.title = this.userInfo.name + "发起" + this.routerParams.name;
      this.formData.content = "";
      this.formData.projectName = "";
      this.formData.companyId = "";
    },
    // 禁用表单
    disableForm() {
      this.flowStatus = true;
    },

    // 接口：校验表单数据
    validateFormData() {
      let flag = null;
      this.$refs.formData.validate((valid) => {
        if (valid) flag = true;
        else flag = false;
      });
      return flag;
    },

    validate() {
      let flag = null;
      this.$refs.formData.validate((valid) => {
        if (valid) flag = true;
        else flag = false;
      });
      return flag;
    },
    async uploadFolder(type) {
      if (type === "guanlianfile") {
        this.node_had.childNodes = []; // 把存起来的node的子节点清空，不然会界面会出现重复树！
        this.getlocalTree(this.node_had, this.resolve_had); // 再次执行懒加载的方法
        this.fileDialog = true;
      } else {
        const params = {
          prjId: this.prjId,
          folderId: "",
          versionId: "",
        };
        await uploader.getHiddenParams(params);
        const array = await uploader.open({ params, once: false, multiple: true, showPanel: false });
        const list = array.map((item) => {
          return {
            checkInDate: item.checkInDate,
            checkInUser: item.checkInUser,
            fileId: item.fileId,
            fileName: item.fileName,
            fileSize: item.fileSize,
            fileType: item.fileType,
            status: item.status,
            uploadType: 1,
            versionIds: item.versionIds
          };
        });
        this.$emit("tableshow", list || [], "upload");
      }
    },
    async getlocalTree(node, resolve) {
      const prjId = this.prjId;
      if (node.level === 0) {
        this.node_had = node; // 这里是关键！在data里面定义一个变量，将node.level == 0的node存起来
        this.resolve_had = resolve; // 同上，把node.level == 0的resolve也存起来
        const params = {
          folderId: 0,
          isRead: 1,
          priviAll: "1",
          prjId,
        };
        const result = await docService.queryTree(params);
        const list = result.data.filter(({ folderId }) => folderId !== "recycle");
        const array = list.map((item) => {
          return {
            isRead: item.isRead,
            priviAll: item.priviAll,
            folderName: item.folderName,
            folderId: item.folderId,
            isFolder: item.isFolder,
            fileType: item.fileType,
            status: item.status,
            uploadType: 2,
            fileVersion: item.fileVersion,
            leaf: item.leaf,
          };
        });
        return resolve(array);
      } else if (node.level !== undefined) {
        const params = {
          folderId: node.data.folderId,
          isRead: node.data.isRead,
          priviAll: node.data.priviAll,
          prjId: this.prjId,
        };
        await docService.queryTree(params).then(({ data }) => {
          const list = data.map((item) => {
            return {
              isRead: item.isRead,
              priviAll: item.priviAll,
              folderName: item.folderName,
              folderId: item.folderId,
              isFolder: item.isFolder,
              fileType: item.fileType,
              status: item.status,
              leaf: item.leaf,
              fileVersion: item.fileVersion,
              uploadType: 2,
            };
          });
          return resolve(list);
        });
      }
    },
    className(row) {
      return tableRowIcon(row);
    },
    async currentOrgChangeHandlerLocal(val, currentChecked) {
      this.currentFileLocal = currentChecked.checkedNodes;
    },
    async filerecelocationBtn() {
      // 对于通用流程关联文档，确定获取文件夹的子级文件
      if (this.currentFileLocal && this.currentFileLocal.length > 0) {
        const list = [];
        // 对于直接选择文件可以先拿出来
        const array = this.currentFileLocal.filter(({ isFolder }) => isFolder === 0);
        const array11 = array.map((item) => {
          return {
            fileName: item.folderName,
            fileId: item.folderId,
            fileType: item.fileType,
            isFolder: item.isFolder,
            status: item.status,
            versionIds: item.fileVersion,
            uploadType: 2,
          };
        });
        // 选中的文件夹点击确定获取子级数据
        for (const item of this.currentFileLocal) {
          const params = {
            folderId: item.folderId,
            isRead: item.isRead,
            priviAll: item.priviAll,
            prjId: this.prjId,
          };
          await docService.queryTree(params).then(({ data }) => {
            const listData = data.map((item) => {
              return {
                fileName: item.folderName,
                fileId: item.folderId,
                fileType: item.fileType,
                isFolder: item.isFolder,
                status: item.status,
                versionIds: item.fileVersion,
                uploadType: 2,
              };
            });
            list.push.apply(list, listData);
          });
        }
        // 将获取到的非文件过滤掉
        const listLocal = list.filter(({ isFolder }) => isFolder === 0);
        // 拼接原来选择的文件
        const floderDatanew = array11.concat(listLocal);
        //过滤一下重复的
        const res = new Map();
        this.floderData = floderDatanew.filter((a) => !res.has(a.fileName) && res.set(a.fileName, 1));
        this.$emit("tableshow", this.floderData || []);
      }
      this.fileDialog = false;
    },
    cancel() {
      this.localTree = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.tree {
  overflow: auto;
  height: 500px;
  max-height: 500px;
  width: 100%;
}
.treeitem {
  display: flex;
  align-items: center;
  user-select: none;
}
.activeShowBar {
  max-height: 300px;
  overflow-y: auto;
}
.img {
  margin-right: 6px;
  height: 16px;
  width: 18px;
  user-select: none;
}
.midd-content {
  line-height: 40px;
}
</style>
